import { render, staticRenderFns } from "./station.vue?vue&type=template&id=3b2e16bc&scoped=true"
import script from "./station.vue?vue&type=script&lang=js"
export * from "./station.vue?vue&type=script&lang=js"
import style0 from "./station.vue?vue&type=style&index=0&id=3b2e16bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e16bc",
  null
  
)

export default component.exports